import { ThemeProvider, createTheme } from '@mui/material/styles';
import "./App.css";
import Navbar from "./components/pageHead/navbar/navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CssBaseline, Grid } from "@mui/material";
import Checkout from "./components/pages/checkout/checkout";
import OrderReceived from "./components/pages/orderReceived/orderReceived";
import Orders from "./components/pages/orders/orders";
import Home2 from "./components/pages/home/home";
import CartView from "./components/pages/cartView/cartView";
import LoginView from "./components/pages/loginView/loginView";
import CategoriesView from "./components/pages/categoriesView/categoriesView";
import RouteHandler from "./components/pages/routeHandler/routeHandler";
import NotFoundPage from "./components/pages/404page/404page";
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from "dayjs";
import UnicoProductsView from "./components/pages/unicoView/unicoView";
import Footer from "./components/pageHead/footer/footer";

dayjs.extend(customParseFormat)

const theme = createTheme({
  palette: {
    primary: {
      main: "#b3071b",
    },
    secondary: {
      main: "#000",
    },
  },
  typography: {
    fontFamily: "Roboto",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <div className="App">
          <Router>
            <Grid style={{ minHeight: "100vh" }} justifyContent={'space-between'} container direction={"column"}>
              <div>
                <Navbar />
                <div className="app-content" style={{ width: "100vw", marginTop:'1%' }}>
                  <Routes>
                    {/* Home */}
                    <Route path="/" element={<Home2 />} />

                    {/* Shop + RouteHandler */}
                    <Route path="/shop/*" element={<RouteHandler />} />

                    {/* Cart */}
                    <Route path="/carrello" element={<CartView />} />

                    {/* Checkout */}
                    <Route path="/cassa" element={<Checkout />} />

                    {/* Order Received */}
                    <Route path="/ordine-ricevuto/:id" element={<OrderReceived />} />

                    {/* Orders */}
                    <Route path="/ordini" element={<Orders />} />

                    {/* Login */}
                    <Route path="/login" element={<LoginView />} />

                    {/* Categories */}
                    <Route path="/categories" element={<CategoriesView />} />

                    {/* Unico Products */}
                    <Route path="/unico" element={<UnicoProductsView />} />

                    {/* 404 fallback */}
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </div>
              </div>
              <Footer />
            </Grid>
          </Router>
        </div>
      </CssBaseline>
    </ThemeProvider>
  );
}

export default App;
